import React, { useState } from "react";
//import { Link } from "react-router-dom";
import "./HomePage.css";

const HomePage = () => {
  const [currentSlide] = useState(0);
const [fadeKey] = useState(0);

  // Hero sections data
  const slides = [
    {
      id: 1,
      title: "OGITS",
      description: "Open Global Information Technology Solutions (OGITS) is an establishment with a specific focus on technologies.",
      image: "/scope%20of%20work.jpeg", // ✅ Remove "/public/"
      url:"./objectives"
    }
  ];
  const programs = [
  
    {
      title: "Purpose",
      description: `Open Global Information Technology Solutions focuses on raising awareness and provide consultation in information technologies, fostering e-services and collaborative initiatives, and providing training in leveraging data for informed decision-making.`,
      linkText: "How to achieve our scope of work",
    //  image: "scope of work.jpeg", // Replace with the actual image path
      alt: "Research Program",
    },
    {
      title: "Vision",
      description: "To be a pioneering Solutions in advancing information technology, empowering leverage data for informed decision-making, innovation, and sustainable development, with a strong focus on enhancing digital literacy.",
      linkText: "How our reach our vision",
    //  image: "scope of work.jpeg", // Replace with the actual image path
      alt: "Market-wide Solutions",
    },
    {
      title: "Our Mission",
      description: `Leveraging partnerships and expertise to support the delivery of comprehensive governance frameworks, advanced technologies, reliable data to drive innovation and address global challenges`,
      linkText: "How our Standards Program works",
    //  image: "mission.jpg", // Replace with the actual image path
      alt: "Technical Standards",
    },
    {
      title: "OGITS Goals",
      description: `• Establish a strong presence as the trusted partner for services.
• Provide enterprise-level solutions to unlock the value of Solutions.
• Support the creation of high-quality data products to meet the expected market's needs.`,
      linkText: "How our Standards Program works",
    //  image: "scope of work.jpeg", // Replace with the actual image path
      alt: "Technical Standards",
    },
  ];

 

  return (
    <div className="homepage">
      {/* Hero Section */}
      <section
        className="hero"
        style={{ backgroundImage: `url(${slides[currentSlide].image})` }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content animate" key={fadeKey}>
          <h1>{slides[currentSlide].title}</h1>
          <p className="hero-description">{slides[currentSlide].description}</p>
         
        </div>
        
      </section>

      
  
      <div className="programs-page">
  {programs.map((program, index) => {
    const isDarkBackground = index % 2 === 0; // True for rgb(106, 91, 136)
    
    return (
      <div
        className={`program-section ${isDarkBackground ? "reverse-layout" : ""}`}
        key={index}
        style={{
          backgroundColor: isDarkBackground ? "rgb(106, 91, 136)" : "#e0e0e0", // Alternating background colors
          color: isDarkBackground ? "white" : "black", // Switch text color based on background
        }}
      >
        <div className="program-text">
          <h2 style={{ color: isDarkBackground ? "white" :" #4C3874" }}>{program.title}</h2>
          {/* Render description as a list if it contains bullets */}
          {program.description.includes("•") ? (
            <ul>
              {program.description
                .split("•")
                .filter((item) => item.trim() !== "") // Remove empty strings
                .map((item, idx) => (
                  <li key={idx}>{item.trim()}</li>
                ))}
            </ul>
          ) : (
            <p>{program.description}</p>
          )}
        </div>
        <div className="program-image">
          {/* <img src={program.image} alt={program.alt} /> */}
        </div>
      </div>
    );
  })}
</div>

 
 
</div>
    
  );
};

export default HomePage;
